import { client } from './client'
import { createResponse } from '../response'
import { ourRecharge, ourPhoneCode, ourArticle, ourRechargeWelcomeOffer } from './translator'
import store from '@/store'

const saveRecharge = async (payload, locale) => {
  try {
    store.dispatch('loader/setLoading', true)
    await client.database().ref('recharge' + '/' + locale).set({
      'hero': payload.hero,
      'heroTop': payload.heroTop,
      'heroH1': payload.heroH1,
      'heroH2': payload.heroH2,
      'heroCta': payload.heroCta,
      'promoHero': payload.promoHero,
      'promoHeroTop': payload.promoHeroTop,
      'promoHeroH1': payload.promoHeroH1,
      'promoHeroH2': payload.promoHeroH2,
      'promoHeroCta': payload.promoHeroCta,
      'promoHeroFineprint': payload.promoHeroFineprint,
      'prebookHero': payload.prebookHero,
      'prebookHeroTop': payload.prebookHeroTop,
      'prebookHeroH1': payload.prebookHeroH1,
      'prebookHeroH2': payload.prebookHeroH2,
      'prebookHeroCta': payload.prebookHeroCta,
      'prebookHeroFineprint': payload.prebookHeroFineprint
    })
    store.dispatch('loader/setLoading', false)
  } catch (error) {
    store.dispatch('loader/setLoading', false)
    throw new Error(error.toString())
  }
}

const fetchRechargeByLocale = async (locale) => {
  try {
    store.dispatch('loader/setLoading', true)
    var res = await client.database().ref('recharge/' + locale).once('value').then(snapshot => {
      store.dispatch('loader/setLoading', false)
      var content = snapshot.val()
      return content === null ? {} : ourRecharge(snapshot.key, content)
    })
    return res
  } catch (error) {
    store.dispatch('loader/setLoading', false)
    throw new Error(error.toString())
  }
}

const saveRechargeWelcomeOffer = async (payload, locale) => {
  try {
    store.dispatch('loader/setLoading', true)
    await client.database().ref('rechargeWelcomeOffer' + '/' + locale).set({
      'hero': payload.hero,
      'heroTop': payload.heroTop,
      'heroH1': payload.heroH1,
      'heroH2': payload.heroH2,
      'rechargeText': payload.rechargeText,
      'promoHero': payload.promoHero,
      'promoHeroTop': payload.promoHeroTop,
      'promoHeroH1': payload.promoHeroH1,
      'promoHeroH2': payload.promoHeroH2,
      'promoRechargeText': payload.promoRechargeText,
      'promoHeroFineprint': payload.promoHeroFineprint,
      'prebookHero': payload.prebookHero,
      'prebookHeroTop': payload.prebookHeroTop,
      'prebookHeroH1': payload.prebookHeroH1,
      'prebookHeroH2': payload.prebookHeroH2,
      'prebookRechargeText': payload.prebookRechargeText,
      'prebookHeroFineprint': payload.prebookHeroFineprint
    })
    store.dispatch('loader/setLoading', false)
  } catch (error) {
    store.dispatch('loader/setLoading', false)
    throw new Error(error.toString())
  }
}

const fetchRechargeWelcomeOfferByLocale = async (locale) => {
  try {
    store.dispatch('loader/setLoading', true)
    var res = await client.database().ref('rechargeWelcomeOffer/' + locale).once('value').then(snapshot => {
      store.dispatch('loader/setLoading', false)
      var content = snapshot.val()
      return content === null ? {} : ourRechargeWelcomeOffer(snapshot.key, content)
    })
    return res
  } catch (error) {
    store.dispatch('loader/setLoading', false)
    throw new Error(error.toString())
  }
}

const fetchPhoneCodes = async (locale) => {
  try {
    store.dispatch('loader/setLoading', true)
    var res = await client.database().ref(`phonecodes-${locale}`).once('value').then(snapshot => {
      var items = []
      snapshot.forEach(function (child) {
        items.push(ourPhoneCode(child.key, child.val()))
      })
      store.dispatch('loader/setLoading', false)
      return createResponse(items)
    })
    return res
  } catch (error) {
    store.dispatch('loader/setLoading', false)
    throw new Error(error.toString())
  }
}

const savePhoneCode = async (payload, locale) => {
  try {
    store.dispatch('loader/setLoading', true)
    var firebaseId = payload.id
    if (payload.id === null) {
      firebaseId = payload.countryCode.replace(/[^\w\s]/gi, '').replace(/\s+/g, '-').toLowerCase()
    }
    await client.database().ref(`phonecodes-${locale}/` + firebaseId).set({
      'pageTitle': payload.pageTitle,
      'pageDescription': payload.pageDescription,
      'keywords': payload.keywords,
      'countryName': payload.countryName,
      'bodyTitle': payload.bodyTitle,
      'body': payload.body,
      'overrideh1': payload.overrideh1
    })
    store.dispatch('loader/setLoading', false)
  } catch (error) {
    store.dispatch('loader/setLoading', false)
    throw new Error(error.toString())
  }
}

const fetchPhoneCodeById = async (id, locale) => {
  try {
    store.dispatch('loader/setLoading', true)
    var res = await client.database().ref(`phonecodes-${locale}` + '/' + id).once('value').then(snapshot => {
      store.dispatch('loader/setLoading', false)
      return ourPhoneCode(snapshot.key, snapshot.val())
    })
    return res
  } catch (error) {
    store.dispatch('loader/setLoading', false)
    throw new Error(error.toString())
  }
}

const removePhoneCode = async (id, locale) => {
  try {
    store.dispatch('loader/setLoading', true)
    await client.database().ref(`phonecodes-${locale}/` + id).remove()
    store.dispatch('loader/setLoading', false)
  } catch (error) {
    store.dispatch('loader/setLoading', false)
    throw new Error(error.toString())
  }
}

const saveArticle = async (payload) => {
  try {
    store.dispatch('loader/setLoading', true)
    var firebaseId = payload.id
    if (payload.id === null || payload.id === undefined) {
      let c = payload.category.replace(/[^\w\s]/gi, '').replace(/\s+/g, '-').toLowerCase()
      let u = payload.url.replace(/[^\w\s]/gi, '').replace(/\s+/g, '-').toLowerCase()
      firebaseId = c + '-' + u
    }
    await client.database().ref(`icg/${payload.locale}/` + firebaseId).set({
      'pageTitle': payload.pageTitle,
      'pageDescription': payload.pageDescription !== undefined ? payload.pageDescription : null,
      'keywords': payload.keywords !== undefined ? payload.keywords : null,
      'locale': payload.locale,
      'category': payload.category,
      'url': payload.url.toLowerCase(),
      'bodyTitle': payload.bodyTitle,
      'leadText': payload.leadText,
      'body': payload.body,
      'imageUrl': payload.imageUrl !== undefined ? payload.imageUrl : null,
      'publishedDate': payload.publishedDate !== undefined ? payload.publishedDate : new Date().toString(),
      'noIndex': payload.noIndex !== undefined ? payload.noIndex : false
    })
    store.dispatch('loader/setLoading', false)
  } catch (error) {
    store.dispatch('loader/setLoading', false)
    throw new Error(error.toString())
  }
}

const fetchArticles = async (locale) => {
  try {
    store.dispatch('loader/setLoading', true)
    var res = await client.database().ref(`icg/${locale}`).once('value').then(snapshot => {
      var items = []
      snapshot.forEach(function (child) {
        items.push(ourArticle(child.key, child.val()))
      })
      store.dispatch('loader/setLoading', false)
      return createResponse(items)
    })
    return res
  } catch (error) {
    store.dispatch('loader/setLoading', false)
    throw new Error(error.toString())
  }
}

const removeArticle = async (id, locale) => {
  try {
    store.dispatch('loader/setLoading', true)
    await client.database().ref(`icg/${locale}/` + id).remove()
    store.dispatch('loader/setLoading', false)
  } catch (error) {
    store.dispatch('loader/setLoading', false)
    throw new Error(error.toString())
  }
}

const fetchArticleById = async (id, locale) => {
  try {
    store.dispatch('loader/setLoading', true)
    var res = await client.database().ref(`icg/${locale}` + '/' + id).once('value').then(snapshot => {
      store.dispatch('loader/setLoading', false)
      return ourArticle(snapshot.key, snapshot.val())
    })
    return res
  } catch (error) {
    store.dispatch('loader/setLoading', false)
    throw new Error(error.toString())
  }
}

const saveConfig = async (payload) => {
  try {
    store.dispatch('loader/setLoading', true)
    await client.database().ref('web-config').set({
      'useRecaptcha': payload.useRecaptcha
    })
    store.dispatch('loader/setLoading', false)
  } catch (error) {
    store.dispatch('loader/setLoading', false)
    throw new Error(error.toString())
  }
}

const fetchConfig = async () => {
  try {
    store.dispatch('loader/setLoading', true)
    var res = await client.database().ref('web-config').once('value').then(snapshot => {
      store.dispatch('loader/setLoading', false)
      var content = snapshot.val()
      return content === null ? {} : content
    })
    return res
  } catch (error) {
    store.dispatch('loader/setLoading', false)
    throw new Error(error.toString())
  }
}

export {
  saveRecharge,
  fetchRechargeByLocale,
  saveRechargeWelcomeOffer,
  fetchRechargeWelcomeOfferByLocale,
  fetchPhoneCodes,
  savePhoneCode,
  fetchPhoneCodeById,
  removePhoneCode,
  saveArticle,
  fetchArticles,
  removeArticle,
  fetchArticleById,
  saveConfig,
  fetchConfig
}



// WEBPACK FOOTER //
// ./src/api/webcontent/index.js